<template>
  <div class="row">
  <div class="col-xs-12 col-md-4 col-lg-2">
    <div class="panel panel-default">
      <div class="panel-heading"><h4>Account Balance</h4></div>
      <div class="panel-body">
        <h3 class="text-success">{{ account.formatted_confirmed_balance }}</h3>
      </div>
    </div>
  </div>
  <div class="col-xs-12 col-md-4 col-lg-2">
    <div class="panel panel-default">
      <div class="panel-heading"><h4>Pending Payments</h4></div>
      <div class="panel-body">
        <h3 class="text-warning">{{ account.formatted_unconfirmed_payments_value }}</h3>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
    export default {
        props: ['account'],
        data: function () {
            return {
                account: this.account
            }
        },
        mounted() {
            // console.log('Component mounted.')
        }
    }
</script>